import AuditorHandler from "./auditorHandler.service";

const auditorHandlerModule = angular
  .module("app.services.auditorHandler", [])
  .service("AuditorHandler", AuditorHandler);

export default auditorHandlerModule;



// WEBPACK FOOTER //
// ./src/services/auditorHandler/auditorHandler.module.js